import { Link, NavLink } from 'react-router-dom';
import styles from'./PageDepth2.module.css';
import classNames from "classnames/bind";
import { useEffect, useRef, useState, useCallback } from 'react';

const cx = classNames.bind(styles);

export default function PageDepth2({ pagedepth2 }) { //페이지 내에 나오는 하위 카테고리
  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(false);

  const checkScrollStatus = useCallback(() => { // 화면 너비보다 메뉴 폭이 넓을 경우 스크롤 가능하게
    const el = containerRef.current;
    if (el) {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      
      // 상태 업데이트
      setIsScrollable(scrollWidth > clientWidth);
      setShowLeftGradient(scrollLeft > 1);
      setShowRightGradient(scrollLeft + clientWidth < scrollWidth - 1);
    }
  }, []);

  useEffect(() => {
    const el = containerRef.current;

    checkScrollStatus();
    if (el) el.addEventListener('scroll', checkScrollStatus);
    window.addEventListener('resize', checkScrollStatus);

    const observer = new MutationObserver(checkScrollStatus);
    if (el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    }

    return () => {
      if (el) el.removeEventListener('scroll', checkScrollStatus);
      window.removeEventListener('resize', checkScrollStatus);
      observer.disconnect();
    };
  }, [pagedepth2, checkScrollStatus]); // 데이터가 바뀌면 재계산

  return (
    <div className={cx("depth2Wrap")}>
      <div
        className={cx("depth2Container", { scrollable: isScrollable })}
        ref={containerRef}
      >
        {pagedepth2.map((item) => (
          item.path ? (
            <NavLink
              key={item.label}
              to={item.path}
              className={({ isActive }) => isActive ? cx("activeLink") : ""}
            >
              {item.label}
            </NavLink>
          ) : (
            <Link key={item.label}>{item.label}</Link>
          )
        ))}
      </div>
      <div className={cx("gradient", "leftGradient", { show: showLeftGradient })}></div>
      <div className={cx("gradient", "rightGradient", { show: showRightGradient })}></div>
    </div>
  );
}
